import { takeLatest, put } from 'redux-saga/effects';
import _isEmpty from 'lodash/isEmpty';
import safeSaga from '../safeSaga';
import { recheckSkuConfigurationError } from '../../actions/getSkuMap/index';

function* checkForErrors() {
  yield put(recheckSkuConfigurationError());
}

export default function* skuMapConfigurationErrorSaga() {
  yield takeLatest('GCC_CONFIGURATOR/EXECUTE_RULES_SUCCESS', safeSaga(checkForErrors));
}
